var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 42 42"}},[_c('path',{attrs:{"d":"M42 20H22V0h-2v20H0v2h20v20h2V22h20z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }